import React from "react";
import { ARCHIV_EMOJI } from "../../constants/projektTypVisuals.js";

const CHIP_CLS =
  "flex min-w-0 flex-col items-center justify-center gap-0.5 px-1.5 py-2 sm:px-2 rounded-md border border-white/10 bg-white/[0.03] text-center sm:flex-row sm:flex-wrap sm:justify-center sm:gap-x-1.5 sm:gap-y-0.5 sm:text-[11px] sm:text-xs text-blue-100/85 lg:flex-1 lg:min-w-[6.5rem]";

/**
 * Kompakte Zähler-Leiste (Emoji + Anzahl + Label) — reine Übersicht, nicht klickbar.
 * Optional `sublabel` für aktiv/archiviert.
 *
 * @param {{ id: string, emoji: string, label: string, count: number, sublabel?: string, title?: string }[]} items
 * @param {number} [archivedCount]
 */
export default function EntityCountsStrip({ items = [], archivedCount = 0 }) {
  if (!items.length && !(archivedCount > 0)) return null;

  return (
    <div
      className="rounded-xl border border-white/10 bg-white/[0.02] px-2 py-2 w-full min-w-0 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:flex lg:flex-wrap gap-1.5 sm:gap-2"
      role="status"
      aria-label="Übersicht verknüpfte Bereiche"
    >
      {items.map((item) => {
        const tooltip =
          item.title ||
          (item.sublabel ? `${item.label}: ${item.sublabel}` : `${item.label}: ${item.count}`);
        return (
          <span key={item.id} title={tooltip} className={CHIP_CLS}>
            <span className="inline-flex items-center gap-1 sm:gap-1.5 min-w-0">
              <span className="text-sm leading-none shrink-0" aria-hidden>
                {item.emoji}
              </span>
              <span className="font-semibold tabular-nums text-blue-50 shrink-0">{item.count}</span>
            </span>
            <span className="text-[10px] sm:text-inherit text-blue-200/55 truncate max-w-full leading-tight">
              {item.label}
            </span>
            {item.sublabel ? (
              <span className="w-full text-[9px] sm:text-[10px] tabular-nums text-blue-200/45 leading-tight">
                {item.sublabel}
              </span>
            ) : null}
          </span>
        );
      })}
      {archivedCount > 0 ? (
        <span title={`${archivedCount} archiviert`} className={`${CHIP_CLS} italic text-blue-200/45`}>
          <span className="inline-flex items-center gap-1 sm:gap-1.5 min-w-0 not-italic">
            <span className="text-sm leading-none shrink-0" aria-hidden>
              {ARCHIV_EMOJI}
            </span>
            <span className="font-semibold tabular-nums shrink-0">{archivedCount}</span>
          </span>
          <span className="text-[10px] sm:text-inherit not-italic leading-tight">archiviert</span>
        </span>
      ) : null}
    </div>
  );
}
